import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';

import conceptoService from '../../../service/logistica/conceptoService';
import tipoMovimientoService from '../../../service/logistica/tipoMovimientoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            filter: {
                nombre: '',
                codigoSunat: '',
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            codigoSunat: '',
            idTipoMovimiento: 0,
            flagCostear: false,
            conceptos: [],
            tiposMovimiento: []
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            codigoSunat: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await conceptoService.eliminar(values);
            else
                response = await conceptoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await conceptoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transporte.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await conceptoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transporte.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await conceptoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.conceptos = this.state.conceptos;
        formValues.tiposMovimiento = this.state.tiposMovimiento;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await conceptoService.obtenerPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombre: response.nombre,
                    codigoSunat: response.codigoSunat,
                    idTipoMovimiento: response.idTipoMovimiento,
                    flagCostear: response.flagCostear,
                    conceptos: this.state.conceptos,
                    tiposMovimiento: this.state.tiposMovimiento
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await conceptoService.registrar(values);
            else
                response = await conceptoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, conceptoService.paginacion);
        const conceptos = await conceptoService.listarSunat();
        const tiposMovimiento = await tipoMovimientoService.listar();
        this.setState({
            loadingSource: false,
            conceptos: conceptos ? conceptos : [],
            tiposMovimiento: tiposMovimiento ? tiposMovimiento : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Concepto"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        )
    }
}